const regions = [
    {
        name: "United States",
        pathname: "https://sellercentral.amazon.com/apps/authorize/consent",
    },
]

export default regions;